import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Auth: attach the JWT to every /api/* request and force re-login on 401.
// Done as a global fetch wrapper so callers don't need to know about tokens.
(function installAuthFetch() {
  const origFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isApi = url.startsWith('/api/') || url.includes('/api/');

    if (isApi) {
      const token = localStorage.getItem('pmplus_token');
      const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
      if (token && !headers.has('Authorization')) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      init = { ...init, headers };
    }

    const res = await origFetch(input, init);

    // Drop the session on auth failure so the next render shows the login form.
    // Skip the login endpoint itself — its 401 is a wrong-password message.
    if (isApi && res.status === 401 && !url.endsWith('/api/auth/login')) {
      localStorage.removeItem('pmplus_user');
      localStorage.removeItem('pmplus_token');
      localStorage.removeItem('pmplus_activeSection');
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      } else {
        window.location.reload();
      }
    }
    return res;
  };
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
